import { baseUrl, handleResponse, handleError, GetHeaders } from "../../apis/common/ApiUtils";

const apiUrl = baseUrl + "Travel/MyVouchers";

export function getMyVouchers() {
    return fetch(`${apiUrl}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getEmpVouchers(employeeId) {
    return fetch(`${apiUrl}/${employeeId}`, GetHeaders()).then(handleResponse).catch(handleError);
}
